module.exports = __webpack_public_path__ + "img/container.9490ae2d.svg";